import React, { useEffect, useState } from "react";
import styled, { css } from "styled-components";

//
import { useWindowPageOffset } from "../../hooks/useWindowPageOffsets";

export default function ToTopBtn() {
  const { yOffset } = useWindowPageOffset();
  const [isHiddenBtn, setIsHiddenBtn] = useState(true);

  useEffect(() => {
    if (yOffset > 875) {
      setIsHiddenBtn(false);
    } else {
      setIsHiddenBtn(true);
    }
  }, [yOffset]);

  function onScrollToTop() {
    window.scrollTo(0, 0);
  }

  return (
    <StyledToTopBtn $isHiddenBtn={isHiddenBtn} onClick={onScrollToTop}>
      <i className="icon icon-arrow-up-double"></i>
    </StyledToTopBtn>
  );
}

const StyledToTopBtn = styled.div`
  position: fixed;
  bottom: 45px;
  right: 30px;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: var(--white);
  box-shadow: rgba(23, 23, 23, 0.1) 0px 0px 12px 2px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.4s ease-in;
  border: 1.5px solid transparent;
  opacity: 1;
  visibility: visible;

  i {
    width: 28px;
    height: 28px;
    background-color: var(--dark-blue);
  }

  &:hover {
    border-color: var(--dark-blue);
  }

  ${({ $isHiddenBtn }) =>
    $isHiddenBtn &&
    css`
      opacity: 0;
      visibility: hidden;
    `}
`;
